import { Button, cardHeaderClasses, CardMedia, CircularProgress, Dialog, DialogContent, Typography } from "@mui/material"
import { Box } from "@mui/system"
import { useEffect } from "react"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import axios from "axios"

import { v4 as uuidv4 } from "uuid";

import { buy_nfts, cancel_nft_sell } from "../../keychain/login"
import { rutas } from "../../rutas/rutas"
// import { especiales } from "../../nft/especiales"
// import { generalNft } from "../../nft/general"
export const SpecialMarket = () => {

  const { configuracion, usuario, especiales , generalNft } = useSelector((state) => state.userSlice);
  const [selector, setSelector] = useState({})
  const [open2, setOpen2] = useState(false);
  const [filtros, setFiltro ]= useState([])
 

  
  const dispatch = useDispatch()
  const handleClose2 = () => {
    setOpen2(false);
  };

  const [cartas, setCartas] = useState([]);

  /**
   * Controla los filtros de checked 
   */
  const handleTransform = (market)=>{
    const deck  = [...especiales, ...generalNft]
    // 
   
    const deckprueba = market.filter(i=> i.account === "mv-deposito" || i.account === "poolbdbkod").reduce((anterior, proximo)=>{
      const result = deck.find(card=> parseInt(proximo?.grouping.ID ) === card?.ide)
        if(anterior.findIndex(card =>  card.ide === parseInt(proximo?.grouping.ID)) === -1  ){
          if(result){
           const prueba = [...anterior, {...result, nft:[{ grupo: proximo.grouping, nftId: proximo.nftId, precio: proximo.price, simbolo: proximo.priceSymbol, vendedor: proximo.account}] }]   
          return prueba
          }
        }else{
          //const carta = prueba.find(card =>  card.id === parseInt(proximo?.grouping.type) )
          const prueba = anterior.map(carta=>  carta.ide === parseInt(proximo?.grouping.ID) ?
          {...carta, nft:[...carta.nft,{ grupo: proximo.grouping, nftId: proximo.nftId, precio: proximo.price, simbolo: proximo.priceSymbol , vendedor: proximo.account}]  } : carta)
         
            
           return prueba
        }
      },[])
      const venidadPorJuego = [105]
      // const deckOrdenado = deckprueba.sort((a, b) => venidadPorJuego.includes(a.ide) );
      const deckOrdenado = deckprueba
      console.log(deckOrdenado)
      // deckprueba.sort((a, b) => (venidadPorJuego.includes(a.ide)  ? -1 : venidadPorJuego.includes(b.ide)? 1 : 0));

      return deckOrdenado;
  }
  const getCard = () =>{

    axios.post(`${rutas.smartContract}`,{"jsonrpc":"2.0","id":1,"method":"find","params":{"contract":"nftmarket","table":"NFTHUESOsellBook","query":{},"limit":1000,"offset":0,"indexes":[]}})
    .then(res=> {
     
        const deckSave =res.data.result
        
    
        // dispatch(setMarket(deckSave))
        setCartas(handleTransform(deckSave))
        // setFiltro(deckSave)
        // dispatch(setDeckPlayer(res.data?.resultado?.deck));
        // dispatch(setInformacion({...res.data?.resultado}));
    })
    .catch(err=> console.log(err))
    
  }
useEffect(()=>{  

  getCard()
},[])



  return (
    <Box sx={{display: 'flex', width: '100%', height: '100%', justifyContent: 'center', overflow: 'auto'}}>

{cartas.length === 0 &&  <CircularProgress color="inherit" />}
    <Box sx={{display: 'flex', flexWrap: 'wrap', width: '100%', height: '50%', alignContent: 'flex-start',justifyContent: 'flex-start'}}>

      {
      cartas?.length > 0 && cartas.map((carta, index) => (
        <Box  sx={{  width: "110px", height: "170px", margin: '10px', position: 'relative' }} key={uuidv4()}>
    
          <CardMedia
            component="img"
            image={carta.url}
            alt="Paella dish"
            sx={{ width: "110px", height: "190px", cursor: 'pointer' }}
            onClick={()=>{           
              setSelector(carta)
              setOpen2(true)
  
             }}
          />
          <Typography sx={{background: carta?.id[0] === "E" ? '#2B21DE':  '#F50202',position: 'absolute', top: '0', left: '0',width: '20px', height: '21px', borderRadius: '50%', textAlign: 'center', color: 'white'}}>{carta?.id[0]}</Typography>
          <Box  sx={{position: 'absolute', top: '0', right: '0', background: carta?.id[0] === "E" ? '#2B21DE':  '#F50202', width: '20px', height: '20px', borderRadius: '50%', textAlign: 'center', color: 'white'}}>{carta?.rareza.toUpperCase()}</Box>
        </Box>
      ))
      }
    </Box>




    {open2 && (
        <Dialog
          open={open2}
          onClose={handleClose2}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogContent
            sx={{
              bgcolor: 'background.paper',
              width: { xs: "260px", sm: "350px", md: "450px", lg: "500px" },
              height: { xs: "500px", sm: "450px", md: "400px", lg: "400px" },
              overflow: "Hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box sx={{display: 'flex', width: '100%', height: '100%'}}>
              <Box sx={{ width: '50%', height: '100%'}}>
              <CardMedia
            component="img"
            image={selector?.url}
            alt="Paella dish"
            sx={{ width: '100%', cursor: 'pointer' }}
        
          />

              </Box>

              <Box  sx={{height: '100%', width: '50%',display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
           
                <Box sx={{height: '90%', width: '100%', overflow: 'auto', }}>
                  {selector?.nft.length > 0 && selector?.nft.map(nft=> <Box key={uuidv4()} sx={{display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid gray'}} >
                    <Typography sx={{color: 'white'}}>Price: {parseFloat(nft.precio).toFixed(2)} {nft?.simbolo}</Typography>
                    {usuario?.user !== nft.vendedor ? <Button onClick={()=>buy_nfts(nft.nftId, nft.precio, nft?.simbolo, 'comprar')}> Buy</Button> : <Button onClick={()=>cancel_nft_sell(nft.nftId)} > Cancel</Button>}
                  </Box>)}
                </Box>
                <Button sx={{height: '10%'}} fullWidth variant="contained" onClick={handleClose2}> Close</Button>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
        )}


    </Box>
  );
};

